import React, { useRef, useState, useEffect, useContext } from "react";
// Components
import Navbar from "../../components/Navbar";
import iconUser from "../../assets/user/account-circle.svg";
import { Formik, Form, Field } from "formik";
import InputText from "../../components/InputText";
import Button from "../../components/Button";
import ListLog from "../../components/ListLog";
import * as S from "./styles";
import validationSchema from "./validations/validationSchema";
import api from "../../services/api";
import { toast } from "react-toastify";
import desmaskIfNumber from "../../utils/desmaskIfNumber";

import history from "../../utils/history";

import { useLocation, useParams } from "react-router-dom";

import SkeletonRadioInput from "../../components/SkeletonRadioInput";
import Skeleton from "../../components/skeleton";
import { Context } from "../../context/globalContext";
import PoPup from "../../components/PopUp";
import CheckBox from "../../components/Checkbox";
import { send } from "process";
import TextArea from "../../components/TextArea";

import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../../components/Button-v2";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";
import ListDepartamento from "../../components/ListDepartamento";
import ListPapelUsuario from "../../components/ListPapelUsuario";

export default function UserRegistration() {
  const formRef = useRef(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const { id } = useParams();
  const params = useQuery();

  const [formData, setFormData] = useState();
  const [disableCnpj, setDisableCnpj] = useState(false);
  const [userSelected, setUserSelected] = useState({ id: null, cpf: null });
  const [sendEmail, setSendEmail] = useState(true);
  const [listEmail, setListEmail] = useState();
  const [existingEmail, setExistingEmail] = useState();
  const [emailExists, setEmailExists] = useState(false);

  const [initialValues, setInitialValues] = useState({
    id: null,
    allowAccess: false,
    idUserPapel: null,
    usuarioPapel: null,
    cpf: "",
    name: "",
    departamento: null,
    papel: null,
    cpfCnpj: "",
    razaosocial: "",
    password: "",
    confirmPassword: "",
    dataInicioVigencia: new Date(),
    dataFimVigencia: null,
    email: "",
    observacao: "",
    status: true,
  });
  const globalContext = useContext(Context);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const checkEmailExist = (emailList) => {
    if (emailList && emailList.length > 0) {
      setEmailExists(true);
      setExistingEmail(emailList[emailList.length - 1]);
      return;
    } else {
      setEmailExists(false);
    }
  };

  async function onBlurCpf(cpf) {
    if (cpf.length !== 11) {
      return;
    }

    globalContext.setIsLoading(true);

    const values = formRef?.current?.values ?? {};
    try {
      const response = await api.get(`api/pessoa/integration/cpfCnpj/${cpf}`);
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        const emails = response?.data?.pessoaContatoEmail;
        const mainEmail = getMainEmail(emails);

        setInitialValues({
          ...initialValues,
          departamento: { id: response?.data?.departamento },
          papel: { id: response?.data?.papel },
          cpf,
          name: response.data.nome,
          password: values?.password,
          cpfCnpj: values?.cpfCnpj,
          razaosocial: values?.razaosocial,
          confirmPassword: values?.confirmPassword,
          usuarioPapel: values?.usuarioPapel,
          email: mainEmail?.email,
        });

        checkEmailExist(emails);
      } else if (!response) {
        setInitialValues({
          ...initialValues,
          departamento: { id: response?.data?.departamento },
          papel: { id: response?.data?.papel },
          cpf,
          name: "",
          password: values?.password,
          cpfCnpj: values?.cpfCnpj,
          razaosocial: values?.razaosocial,
          confirmPassword: values?.confirmPassword,
          usuarioPapel: values?.usuarioPapel,
        });
        toast.error(
          "Erro ao buscar os dados deste cpf, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cpf, tente novamente mais tarde!"
        );
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  }

  async function onBlurCnpj(cpfCnpj) {
    if (cpfCnpj.length < 11) {
      return;
    }

    const values = formRef.current.values;

    globalContext.setIsLoading(true);

    try {
      const response = await api.get(
        `api/pessoa/integration/cpfCnpj/${cpfCnpj}`
      );
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        setInitialValues({
          ...initialValues,
          cpfCnpj,
          departamento: { id: response?.data?.departamento },
          papel: { id: response?.data?.papel },
          password: values.password,
          confirmPassword: values.confirmPassword,
          razaosocial: response.data.nome,
          usuarioPapel: {
            pessoaId: response.data.id,
          },
        });
      } else if (!response) {
        setInitialValues({
          ...initialValues,
          departamento: { id: response?.data?.departamento },
          papel: { id: response?.data?.papel },
          password: values.password,
          confirmPassword: values.confirmPassword,
          razaosocial: "",
          cpfCnpj,
          usuarioPapel: null,
        });
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      setInitialValues({
        ...initialValues,
        papel: values.papel,
        departamento: values.departamento,
        password: values.password,
        confirmPassword: values.confirmPassword,
        razaosocial: "",
        cpfCnpj,
        usuarioPapel: null,
      });
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  }

  useEffect(() => {
    const cnpj = params.get("cnpj");
    if (cnpj && cnpj !== "" && cnpj !== null) {
      getExistUser(desmaskIfNumber(cnpj));
    }
  }, []);

  const getExistUser = async (cpfCnpj) => {
    onBlurCnpj(cpfCnpj);
    setDisableCnpj(true);
  };

  useEffect(() => {
    Object.keys(formRef.current.values).length >= 1
      ? setFormData(true)
      : setFormData(false);
  }, [formRef, formData]);

  const getMainEmail = (emails) => {
    let mainEmail;
    for (let index = 0; index < emails.length; index++) {
      let currentElement = emails[index];
      if (currentElement.emailPrincipal === true) {
        mainEmail = currentElement;
        break;
      } else {
        mainEmail = null;
      }
    }
    return mainEmail;
  };

  const getDataByUserId = async () => {
    try {
      const response = await api.get(`api/usuarios/${id}`);
      if (response.status === 200 || response.status === 201) {
        const emails = response?.data?.pessoa.pessoaContatoEmail;
        const mainEmail = getMainEmail(emails);
        setInitialValues({
          ...initialValues,
          id: response?.data?.id,
          cpf: response?.data?.username,
          name: response?.data?.pessoa?.nome,
          departamento: {
            id: response?.data?.usuarioPapel?.departamento?.id,
            descricao: response?.data?.usuarioPapel?.departamento?.descricao,
          },
          papel: {
            id: response?.data?.usuarioPapel?.papel?.id,
            descricao: response?.data?.usuarioPapel?.papel?.descricao,
          },
          cpfCnpj: response?.data?.usuarioPapel?.pessoa?.cpfCnpj,
          razaosocial: response?.data?.usuarioPapel?.pessoa?.nome,
          idUserPapel: response?.data?.usuarioPapel?.id || null,
          usuarioPapel: {
            pessoaId: response?.data?.usuarioPapel?.pessoa?.id,
          },
          dataInicioVigencia: response?.data?.usuarioPapel?.dataInicioVigencia,
          dataFimVigencia: response?.data?.usuarioPapel?.dataFimVigencia,
          status: response?.data?.status,
          pessoa: response?.data?.usuarioPapel?.pessoa || null,
          password: "",
          confirmPassword: "",
          email: mainEmail?.email,
          observacao: response?.data?.observacao,
        });
        setListEmail(emails);
        checkEmailExist(emails);
      } else if (!response) {
        toast.error("Erro ao buscar os dados, tente novamente mais tarde!");
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar os dados, tente novamente mais tarde!");
      }
    }
  };

  useEffect(() => {
    if (id) {
      getDataByUserId();
    }
  }, [id]);

  const sendData = async (values) => {
    console.log(values);
    if (!values.name || values.name === "") {
      toast.error("Preencha um CPF válido");
      return;
    }

    if (!values.razaosocial || values.razaosocial === "") {
      toast.error("Preencha um CNPJ válido");
      return;
    }

    if (!sendEmail) {
      if (
        values.password &&
        values.password !== "" &&
        values.password !== null
      ) {
        if (values.password !== values?.confirmPassword) {
          toast.error("Senha e confirmação de senha diferentes");
          return;
        }
      }
    }

    globalContext.setIsLoading(true);

    let form = {
      id: id ? values?.id : null,
      username: values.cpf,
      email: values?.email,
      enviarEmail: sendEmail,
      senha:
        values.password === "" || sendEmail === true ? null : values.password,
      status: true,
      allowAccess: initialValues.allowAccess,
      observacao: values.observacao,
      usuarioPapel: {
        id: values?.idUserPapel,
        papel: values?.papel,
        idPapel: values?.papel?.id,
        departamento: values?.departamento,
        idDepartamento: values?.departamento?.id,
        dataInicioVigencia:
          id && id !== null ? values?.dataInicioVigencia : new Date(),
        dataFimVigencia:
          id && initialValues.status === false ? null : values?.dataFimVigencia,
        pessoaId: values?.usuarioPapel?.pessoaId,
        pessoa: values?.pessoa,
      },
    };

    const handleEditing = async () => {
      try {
        const response = await api.put(`api/usuarios/${values?.id}`, form);
        if (response && (response.status === 201 || response.status === 200)) {
          getDataByUserId();
          toast.success("Dados atualizados com sucesso!");
        } else if (!response) {
          toast.error(
            "Erro ao atualizar, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao atualizar, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    const handleCreate = async () => {
      try {
        const response = await api.post("api/usuarios", form);
        if (response && (response.status === 201 || response.status === 200)) {
          toast.success("Dados cadastrados com sucesso!");
        } else if (!response) {
          toast.error("Erro ao salvar, verifique os dados e tente novamente!");
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao salvar, verifique os dados e tente novamente!");
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    if (
      existingEmail ||
      (values?.email && values?.email !== null && values?.email !== "")
    ) {
      if (id || values?.id) {
        handleEditing();
      } else {
        handleCreate();
      }
    } else {
      globalContext.setIsLoading(false);
      toast.error(
        "É necessário que tenha cadastrado ao menos 1 e-mail para concluir o cadastro."
      );
    }
  };

  const sendPasswordRecoveryEmail = async () => {
    globalContext.setIsLoading(true);

    try {
      const response = await api.post(
        `api/recuperarSenha/usuario/recuperarSenha?email=${initialValues.email}&cpfCnpj=${initialValues.cpf}`,
        null
      );
      if (response && response.status === 204) {
        toast.success(
          "Um e-mail foi enviado com um link para mudar a sua senha."
        );
      } else if (!response) {
        toast.error("Erro ao salvar, verifique os dados e tente novamente!");
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao salvar, verifique os dados e tente novamente!");
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    globalContext.setIsLoading(true);
    const values = formRef.current.values;
    const form = {
      id: id ? values?.id : null,
      username: values.cpf,
      senha: values.password === "" ? null : values.password,
      status: false,
      allowAccess: initialValues.allowAccess,
      usuarioPapel: {
        id: values?.idUserPapel,
        papel: values.papel,
        departamento: values.departamento,
        dataInicioVigencia:
          id && id !== null ? values?.dataInicioVigencia : new Date(),
        dataFimVigencia: new Date(),
        pessoaId: values?.usuarioPapel?.pessoaId,
      },
    };

    try {
      const response = await api.put(`api/usuarios/${values.id}`, form);
      if (
        response &&
        (response.status === 201 ||
          response.status === 200 ||
          response.status === 204)
      ) {
        getDataByUserId();
        toast.success("Usuario inativado com sucesso!");
      } else if (!response) {
        toast.error(
          "Erro ao inativar dados, verifique os dados e tente novamente!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao inativar dados, verifique os dados e tente novamente!"
        );
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (formRef.current) {
      if (formRef.current.isValid) {
        sendData(formRef.current.values);
      }
    }
  };

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={iconUser} />
            <div>
              <S.Title>Cadastro de Usuário</S.Title>
              <S.Description>Informações básicas para login</S.Description>
            </div>
          </S.BoxUser>
        </S.Header>

        {!id && (
          <S.Content>
            <S.Containerbox>
              <div className="textbox">
                <S.TitleBox>Permitir acesso ao sistema retaguarda:</S.TitleBox>
              </div>
              <S.ClassInput>
                <S.InputRadio
                  type="radio"
                  name="allow_access"
                  value={true}
                  checked={initialValues.allowAccess === true}
                  onChange={() => {
                    const values = formRef.current.values;
                    setInitialValues({
                      ...initialValues,
                      papel: values.papel,
                      departamento: values.departamento,
                      password: values.password,
                      confirmPassword: values.confirmPassword,
                      allowAccess: true,
                    });
                  }}
                ></S.InputRadio>
                <S.LabelInput> Sim</S.LabelInput>
                <S.InputRadio
                  type="radio"
                  name="allow_access"
                  value={false}
                  checked={initialValues.allowAccess === false}
                  onChange={() => {
                    const values = formRef.current.values;
                    setInitialValues({
                      ...initialValues,
                      papel: values.papel,
                      departamento: values.departamento,
                      password: values.password,
                      confirmPassword: values.confirmPassword,
                      allowAccess: false,
                    });
                  }}
                ></S.InputRadio>
                <S.LabelInput>Não</S.LabelInput>
              </S.ClassInput>
            </S.Containerbox>
          </S.Content>
        )}

        <S.Content>
          <Formik
            innerRef={formRef}
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={(values) => handleSubmit()}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form autocomplete="off">
                <Field
                  name="cpf"
                  id="cpf"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        currency="false"
                        {...field}
                        type="text"
                        disabled={id && id !== null}
                        width="90%"
                        label="CPF:"
                        maskChar=""
                        mask="999.999.999-99"
                        error={errors.cpfCnpj && touched.cpfCnpj}
                        onChange={(e) => {
                          onBlurCpf(desmaskIfNumber(e.target.value));
                          setFieldValue("cpf", e.target.value);
                        }}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <Field
                  name="name"
                  id="name"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        disabled
                        type="text"
                        width="90%"
                        label="Nome:"
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <Field
                  name="email"
                  id="email"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="90%"
                        label="Email:"
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <Field
                  name="departamento"
                  id="departamento"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <ListDepartamento
                        {...field}
                        type="text"
                        disabled={id && values.status === false}
                        width="50%"
                        label="Departamento:"
                        value={initialValues.departamento?.id}
                        required={true}
                        onChange={(e) => {
                          setInitialValues({
                            ...initialValues,
                            departamento: e,
                          });
                        }}
                        error={errors.departamento && touched.departamento}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <Field
                  name="papel"
                  id="papel"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <ListPapelUsuario
                        {...field}
                        type="text"
                        width="50%"
                        disabled={id && values.status === false}
                        label="Papel:"
                        value={initialValues.papel?.id}
                        required={true}
                        onChange={(e) => {
                          setInitialValues({
                            ...initialValues,
                            papel: e,
                          });
                        }}
                        error={errors.papel && touched.papel}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <Field
                  name="cpfCnpj"
                  id="cpfCnpj"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="90%"
                        label="Cpf/Cnpj:"
                        disabled={
                          (id && values.status === false) || disableCnpj
                        }
                        maskChar=""
                        //autoComplete={"new-password"}
                        currentType="cpf/cnpj"
                        currency="false"
                        value={values.cpfCnpj}
                        onBlur={(e) => {
                          onBlurCnpj(desmaskIfNumber(e?.target?.value));
                          setFieldValue("cpfCnpj", e?.target?.value);
                        }}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <Field
                  name="razaosocial"
                  id="razaosocial"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        disabled
                        type="text"
                        width="90%"
                        label="Nome/Razão Social:"
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <S.TextAreaBox>
                  <Field
                    name="observacao"
                    id="observacao"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <TextArea
                          {...field}
                          type="text"
                          label="Observação:"
                          onChange={(e) => {
                            setFieldValue("observacao", e.target.value);
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.TextAreaBox>

                {!id &&
                  (!globalContext.isLoading ? (
                    <S.LabelCheckBox>
                      <CheckBox
                        marked={sendEmail}
                        onClick={() => setSendEmail((prevState) => !prevState)}
                      />
                      <div id="checkbox">
                        Enviar email para configurar senha?
                      </div>
                    </S.LabelCheckBox>
                  ) : (
                    <Skeleton type="input" />
                  ))}
                {id ? (
                  <></>
                ) : !sendEmail ? (
                  <S.PasswordFields>
                    <Field
                      name="password"
                      id="password"
                      render={({ field }) =>
                        !globalContext.isLoading ? (
                          <InputText
                            {...field}
                            currency="false"
                            inputType="password"
                            type="password"
                            width="90%"
                            label="Senha:"
                            icon="true"
                            visState="false"
                            disabled={id && values.status === false}
                            autoComplete={"new-password"}
                            onChange={(e) => {
                              setFieldValue("password", e.target.value);
                            }}
                          />
                        ) : (
                          <Skeleton type="input" />
                        )
                      }
                    />

                    <Field
                      name="confirmPassword"
                      id="confirmPassword"
                      render={({ field }) =>
                        !globalContext.isLoading ? (
                          <InputText
                            {...field}
                            currency="false"
                            inputType="password"
                            type="password"
                            width="90%"
                            label="Confirmar senha:"
                            icon="true"
                            visState="false"
                            disabled={id && values.status === false}
                            onChange={(e) => {
                              setFieldValue("confirmPassword", e.target.value);
                            }}
                          />
                        ) : (
                          <Skeleton type="input" />
                        )
                      }
                    />
                  </S.PasswordFields>
                ) : (
                  <></>
                )}
              </Form>
            )}
          </Formik>
          <S.ButtonContainer>
            <Button button="primary" onClick={history.goBack}>
              Voltar
            </Button>
            {id && (
              <Button
                button="primary"
                onClick={() => sendPasswordRecoveryEmail()}
              >
                Redefinir Senha
              </Button>
            )}
            {id && initialValues.status === true ? (
              <Button
                button="primary"
                className="inativar"
                onClick={() => {
                  setPopupOpen(true);
                  setUserSelected({
                    id: initialValues.id,
                    cpf: initialValues.cpf,
                  });
                }}
              >
                Inativar
              </Button>
            ) : (
              <></>
            )}
            <Button button="primary" onClick={() => handleSubmit()}>
              {id && initialValues.status === false
                ? "Ativar cadastro"
                : "Salvar cadastro"}
            </Button>
          </S.ButtonContainer>
        </S.Content>
        <S.Content>
          <ListLog entidadeId={id} nomeEntidade="Usuario" />
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Content>
      </S.Wrapper>
      {popupOpen && (
        <PoPup
          setIsLoading={globalContext.setIsLoading}
          setOpenPopup={setPopupOpen}
          updateList={handleDelete}
          userSelected={userSelected}
          endPoint="/api/usuarios/"
          useMask="##.###.###/####-##"
          inativar={true}
          showCpfCnpj={true}
          textExclude={"Você deseja realmente inativar este usuário?"}
          messageFailed={"Error ao inativar o usuario com o CPF"}
          messageSuccess={"Sucesso ao inativar o usuário"}
        />
      )}
    </>
  );
}
